module.exports = __webpack_public_path__ + "files/878681400fcfe76cfc9f26f76e77cf45.png";